import studyUpdate from "@/router/props/study/update";
import BaseForm from "@/views/BaseForm.vue";
import Studies from "@/views/Studies/Studies.vue";
import { modulesSystem, modulesSystemLevel } from "@/constants";

export default [
  // {
  //   path: "/study",
  //   name: "study",
  //   meta: {
  //     ShowNav: true,
  //     title: "Estudos",
  //     modulesNeeded: [modulesSystem.studies, modulesSystemLevel.read],
  //     navBarTab: 10,
  //   },
  //   component: Studies,
  //   props: studyUpdate,
  // },
];
